import { Link, useLocation } from 'react-router-dom';
import { Compass } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/states';
import { PageContainer } from '@/app/shell/app-shell';

export function NotFoundPage() {
  const location = useLocation();
  return (
    <PageContainer>
      <EmptyState
        icon={<Compass className="size-5" />}
        title="Page not found"
        description={`There is nothing at ${location.pathname}.`}
        action={
          <Button variant="secondary" size="sm" asChild>
            <Link to="/">Go to the start page</Link>
          </Button>
        }
      />
    </PageContainer>
  );
}

export default NotFoundPage;
